import React from 'react';
import _ResponsiveContentGrid from 'src/components/Modules/ResponsiveContentGrid';

import { compose } from 'redux';
import ContentGroupHOC from '../HOC';

import { get } from 'lodash';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { errKeys } from 'src/constrains/DraggableModules/tools';

const ResponsiveContentGrid = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    extraProps,
  } = props || {};
  const { breakpoint } = extraProps || {};
  const { options, animations, hoverAnimations } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  //
  // const inUsePages = get(options, 'inUsePages') || [];
  // const pendingPages = get(options, 'pendingPages') || [];
  // const previousPages = get(options, 'previousPages') || [];
  // const contentPages = [...inUsePages, ...pendingPages, ...previousPages];
  const contentPageToShowError =
    get(specificError, errKeys.ResponsiveContentGrid.contentPageToShow) || [];
  const contentPageToShowMismatchError =
    get(
      specificError,
      errKeys.ResponsiveContentGrid.contentPageToShowMismatch,
    ) || [];

  return (
    <_ResponsiveContentGrid
      contentPageList={options}
      breakpoint={breakpoint}
      specificError={{
        contentPageToShowError,
        contentPageToShowMismatchError,
        //contentPagesHasError,
        ...specificError,
      }}
      staticData={staticData}
      contentPages={dynamicData}
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      droppableId={droppableId}
      animations={animations}
      hoverAnimations={hoverAnimations}
    />
  );
};
export default compose(ContentGroupHOC)(ResponsiveContentGrid);
